import axios from 'axios';
import { GetPurchaseHistoryInput } from 'views/order-feed/features/purchase-history/types/get-purchase-history-input.type';
import { PurchaseHistory } from 'views/order-feed/features/purchase-history/types/purchase-history.type';

// GET
// /ewosapi/v1/order/analytics/{globalCompanyId}/purchasehistory
export const getPurchaseHistory = async (
  globalCompanyId: string,
  getPurchaseHistory: GetPurchaseHistoryInput
): Promise<PurchaseHistory> => {
  const res = await axios.post(`/ewosapi/v1/order/analytics/${globalCompanyId}/purchasehistory`, getPurchaseHistory);
  return res.data;
};
